/**
 * @param {Date} date
 * @returns {string} YYYY-MM-DD
 */
export const toDateKey = (date) => date.toISOString().split("T")[0];

/**
 * @param {Date} date
 * @param {string[]} exceptionDates
 * @returns {boolean}
 */
export const isExceptionDate = (date, exceptionDates) =>
  exceptionDates.includes(toDateKey(date));

/**
 * @param {Date} startDate
 * @returns {Date} next Wednesday from startDate (or startDate if it is Wednesday)
 */
export const getNextWednesday = (startDate) => {
  const d = new Date(startDate);
  const day = d.getDay();
  const daysUntilWednesday = (3 - day + 7) % 7;
  d.setDate(d.getDate() + daysUntilWednesday);
  return d;
};

/**
 * @param {Date} date
 * @returns {number} 1-5, week of month (1st week = 1, etc.)
 */
export const getWeekOfMonth = (date) => Math.ceil(date.getDate() / 7);
